import { Box, Card, CardContent, Typography } from '@mui/material'
import {
  UI_COLOR_BLACK,
  UI_COLOR_BORDER_MEDIUM,
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_ALT,
  UI_COLOR_TEXT_TERTIARY,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export default function ReportTraceabilityCard({
  title,
  value,
  valueTitle,
  icon,
  helperText,
  accent = UI_COLOR_PRIMARY,
  contentSx = {}
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `3px solid ${UI_COLOR_BORDER_MEDIUM}`,
        backgroundColor: UI_COLOR_WHITE,
        height: '100%',
        boxShadow: 'none'
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.75,
          p: 2.5,
          '&:last-child': { pb: 2.5 },
          ...contentSx
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: accent,
            color: UI_COLOR_WHITE,
            flexShrink: 0
          }}
        >
          {icon}
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              color: UI_COLOR_BLACK
            }}
          >
            {title}
          </Typography>

          <Typography
            title={valueTitle}
            sx={{
              fontSize: 24,
              fontWeight: 700,
              color: UI_COLOR_PRIMARY_ALT,
              lineHeight: 1.15,
              minWidth: 0,
              whiteSpace: 'normal',
              overflowWrap: 'anywhere',
              wordBreak: 'break-word'
            }}
          >
            {value}
          </Typography>

          {helperText ? (
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                mt: 0.75,
                color: UI_COLOR_TEXT_TERTIARY
              }}
            >
              {helperText}
            </Typography>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  )
}
